import { KeyboardArrowDown } from "@mui/icons-material";
import { Button, CircularProgress, Dialog, InputBase, MenuItem, Select } from "@mui/material";
import { Check, X } from "lucide-react";
import React, { useEffect, useState } from "react";

const ContactAddedModal = ({ open, setOpen, name }) => {
    useEffect(()=> {{
        setTimeout(()=> {
            setOpen(false)
        },5000)
    }})
  return (
    <Dialog open={open} fullWidth={false} maxWidth={"sm"}
    
    
    BackdropProps={{
        style: { backgroundColor: "rgb(144,150,160,0.6)" },
      }}
    >
    <X className="absolute top-4 right-4 h-5 w-5 text-gray-500 cursor-pointer" onClick={() => setOpen(false)} />
      <div className="lg:px-8 px-4 pt-14 pb-10">

     <div className="bg-green-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
     <Check className="mx-auto h-8 w-8 text-green-500" />
     </div>
        <div className="lg:text-[20px] text-[#030229]  text-[15px] font-semibold  text-center mb-4">Contact Added!</div>


        <div className="lg:text-[14px] text-[13px] text-center">
       {name} has been added to your contacts successfully.
        </div>


      

      
      </div>
    </Dialog>
  );
};

export default ContactAddedModal;
